import React from "react";
import { ShieldCheck, Lock, FileCheck, Landmark } from "lucide-react";
import { useT } from "@/i18n/LanguageContext";

const PILLAR_ICONS = [ShieldCheck, Landmark, FileCheck, Lock];
const PILLAR_KEYS = ["aml", "bank", "licensed", "registered"];

const MINERALS_IMG =
  "https://images.unsplash.com/photo-1624365169364-0640dd10e180?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxnb2xkJTIwYnVsbGlvbiUyMGJhcnN8ZW58MHx8fHwxNzgzNTkxNTU2fDA&ixlib=rb-4.1.0&q=85";

const Manifesto = () => {
  const { t } = useT();
  return (
    <section id="compliance" data-testid="compliance-section" className="relative py-24 md:py-32">
      <div className="max-w-6xl mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <img
              src={MINERALS_IMG}
              alt="Gold bullion — LBMA certified channels"
              className="w-full h-72 md:h-full object-cover border border-[#D4AF37]/25"
              loading="lazy"
              data-testid="compliance-image"
            />
          </div>

          <div
            className="lg:col-span-7 order-1 lg:order-2 relative bg-[#020C1B] border border-[#D4AF37] p-8 md:p-12"
            style={{ borderLeftWidth: 6, borderLeftColor: "#7A1C1C", boxShadow: "0 0 60px rgba(212,175,55,0.06)" }}
            data-testid="manifesto-block"
          >
            <div className="flex items-center gap-3 mb-6">
              <div className="hairline-crimson" />
              <span className="font-sans text-[11px] tracked uppercase text-[#D4AF37]" style={{ letterSpacing: "0.32em" }}>
                {t.compliance.eyebrow}
              </span>
            </div>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-bone leading-[1.08] mb-6" style={{ fontWeight: 500 }}>
              {t.compliance.h2a}<br />
              <span className="text-[#D4AF37] italic">{t.compliance.h2b}</span>
            </h2>

            <p className="font-sans text-[15px] md:text-base text-steel leading-[1.75] mb-8">
              {t.compliance.body}
            </p>

            <div className="grid grid-cols-2 gap-4 pt-6 border-t border-[#D4AF37]/20">
              {t.compliance.pillars.map((p, i) => {
                const Icon = PILLAR_ICONS[i] || ShieldCheck;
                return (
                  <div key={PILLAR_KEYS[i]} className="flex items-start gap-3" data-testid={`pillar-${PILLAR_KEYS[i]}`}>
                    <div className="inline-flex items-center justify-center w-9 h-9 border border-[#D4AF37]/40 text-[#D4AF37] shrink-0">
                      <Icon size={16} />
                    </div>
                    <div>
                      <div className="font-sans text-[10px] uppercase tracked text-[#D4AF37]" style={{ letterSpacing: "0.24em" }}>
                        {p.k}
                      </div>
                      <div className="font-serif text-bone text-[17px] mt-1 leading-tight">{p.v}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
